import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import * as reducers from 'Store/reducers';
import { sendAnalyticsEventById } from 'Store/stats/actions';

let scrollHideTimeout;
let scrollTimeout;

class ScrollToBanner extends React.Component {
  static scrollTo(start, end) {
    // https://github.com/danro/jquery-easing/blob/master/jquery.easing.js#L89-L92
    const easing = (t, b, c, d) => {
      /* eslint-disable */
      if ((t /= d / 2) < 1) return (-c / 2) * (Math.sqrt(1 - t * t) - 1) + b;
      return (c / 2) * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
      /* eslint-enable */
    };

    const distance = end - start;
    const animationDuration = 400;
    const increment = 5;
    let currentTime = 0;
    const animateScroll = () => {
      const newPosition = easing(
        currentTime,
        start,
        distance,
        animationDuration
      );
      window.scroll(0, newPosition);
      currentTime += increment;
      if (currentTime <= animationDuration) {
        scrollTimeout = window.setTimeout(animateScroll, increment);
      }
    };
    animateScroll(start);
  }

  constructor(props) {
    super(props);

    this.state = {
      scrollHandlerActive: false,
    };

    this.handleUIHintClick = this.handleUIHintClick.bind(this);
  }

  componentDidMount() {
    this.handleUIHintScroll(this.props);
  }

  componentDidUpdate() {
    this.handleUIHintScroll(this.props);
  }

  componentWillUnmount() {
    window.cancelAnimationFrame(scrollHideTimeout);
    window.clearTimeout(scrollTimeout);
  }

  handleUIHintClick(e) {
    ScrollToBanner.scrollTo(window.pageYOffset, this.props.scrollToPx);
    this.props.sendAnalyticsEventById(this.props.hintId);
  }

  handleUIHintScroll(props) {
    const { hintId, bannerIsReady, seenHint, scrollToPx, activeUser } = props;
    if (!activeUser || !bannerIsReady || this.state.scrollHandlerActive) return;
    this.setState({ scrollHandlerActive: true });

    const windowHeight = window.outerHeight;
    const scrollToPoint = scrollToPx - windowHeight * 0.33;

    const checkOffset = () => {
      if (!seenHint) {
        if (window.pageYOffset > scrollToPoint) {
          // Give it some time to animate out.
          window.setTimeout(this.props.sendAnalyticsEventById, 1000, hintId);
        } else {
          scrollHideTimeout = window.requestAnimationFrame(checkOffset);
        }
      }
    };
    checkOffset();
  }

  render() {
    const { bannerIsReady, render, seenHint } = this.props;
    if (!bannerIsReady) return null;
    return render({
      handleUIHintClick: e => this.handleUIHintClick(e),
      seenHint,
    });
  }
}

ScrollToBanner.propTypes = {
  scrollToPx: PropTypes.number,
  hintId: PropTypes.string,
  bannerIsReady: PropTypes.bool.isRequired,
  render: PropTypes.func.isRequired,
  seenHint: PropTypes.bool,
  sendAnalyticsEventById: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
  return {
    activeUser: reducers.getActiveUser(state),
    seenHint: reducers.getHasUIHintBeenSeen(state, props.hintId),
  };
};

export default connect(mapStateToProps, { sendAnalyticsEventById })(
  ScrollToBanner
);
